import React from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { PromotionContestV1 } from '../types/ContestTypes';
import { NumberField } from '../../../../../ui/_fields/NumberField/NumberField';
import { TextField } from '../../../../../ui/_fields/TextField/TextField';
import { TextareaFieldInput } from '../../../../../ui/_fields/TextareaFieldInput/TextareaFieldInput';
import { CONTEST_MAX, ContestRewardType } from '../contestShared';
import { EpisodeBookValidationMessage } from './EpisodeBookValidationMessage';
import { EpisodeUuidLookupHint } from './EpisodeUuidLookupHint';

interface ContestV1PanelProps {
  values: PromotionContestV1;
  errors: Partial<Record<keyof PromotionContestV1, string>> | undefined;
  touched: Partial<Record<keyof PromotionContestV1, boolean>> | undefined;
  promotionStoryUuid: string | null;
  onChange: (event: React.ChangeEvent) => void;
  onRewardAmountChange: (value: number) => void;
}

export function ContestV1Panel(props: ContestV1PanelProps) {
  const {
    values,
    errors,
    touched,
    promotionStoryUuid,
    onChange,
    onRewardAmountChange,
  } = props;

  const handleRewardAmountChange = (event: React.ChangeEvent) => {
    const { value } = event.target as HTMLInputElement;
    onRewardAmountChange(value === '' ? 0 : Number(value));
  };

  return (
    <>
      <Row className="mb-3">
        <Col md={12}>
          <TextField
            label="Episode UUID"
            name="v1.episodeUuid"
            placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
            value={values.episodeUuid}
            onChange={onChange}
            error={touched?.episodeUuid ? errors?.episodeUuid : ''}
          />
          <EpisodeUuidLookupHint uuid={values.episodeUuid} />
          <EpisodeBookValidationMessage
            storyUuid={promotionStoryUuid}
            episodeUuid={values.episodeUuid}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Reward type</Form.Label>
            <Form.Control
              as="select"
              name="v1.rewardType"
              value={values.rewardType}
              onChange={onChange}
            >
              <option value={ContestRewardType.Sapphires}>Sapphires</option>
              <option value={ContestRewardType.Hearts}>Hearts</option>
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={6}>
          <NumberField
            label="Reward amount"
            name="v1.rewardAmount"
            min="0"
            step="1"
            value={values.rewardAmount}
            onChange={handleRewardAmountChange}
            error={touched?.rewardAmount ? errors?.rewardAmount : ''}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={12}>
          <TextField
            label="Title"
            name="v1.title"
            placeholder="Mailbox / notification title"
            value={values.title}
            onChange={onChange}
            error={touched?.title ? errors?.title : ''}
            maxLength={CONTEST_MAX.title}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col md={12}>
          <TextareaFieldInput
            rows={4}
            label="Message"
            name="v1.message"
            placeholder="Message body"
            value={values.message}
            onChange={onChange}
            error={touched?.message ? errors?.message : ''}
            maxLength={CONTEST_MAX.message}
          />
        </Col>
      </Row>
    </>
  );
}
